import React, { useEffect, useState } from "react";
import Card from "components/Card";
import Input from "components/Form/Input";
import PageTitle from "components/Title/Page";
import _ from "lodash";
import SpinnerMedium from "components/Spinner/Medium";
import { infoService } from "common/services/info";
import ComboBox from "components/Form/Combobox";
import Button from "components/Form/Button";
import { useNavigate } from "react-router-dom";
import Textarea from "components/Form/Textarea";
import EmptyForm from "components/Form/Empty";
import SingleImageUploader from "components/Form/Input/Image/SingleUploader";
import MultiBadgeCombo from "components/Form/MultiBadgeCombo";
import MultiImageUploader from "components/Form/Input/Image/MultiUploader";
import { useModal } from "components/Modal/Simple";
import FileUploadingSpinner from "common/components/FileUploadingSpinner";

const EventEditForm = ({ eventInfo, onSave = async (formData) => { }, hideId = false, hideClinic = false }) => {

    const [selectedClinicItem, setSelectedClinicItem] = useState(null);
    const [formData, setFormData] = useState(null);
    const { Modal: UploadingModal, openModal: openUploadingModal, closeModal: closeUploadingModal } = useModal();
    const navigate = useNavigate();

    useEffect(() => {
        if (_.isNil(eventInfo)) {
            return;
        }
        setFormData(eventInfo);
        if (!hideClinic) {
            const clinics = infoService.getClinics();
            const clinicItem = clinics.find((item) => item.id === eventInfo.clinic?.id);
            console.log("[EventEditPage] fetchEventInfo clinicItem", clinicItem);
            setSelectedClinicItem(clinicItem);
        }
    }, [eventInfo])

    const handleSave = async () => {
        openUploadingModal();
        await onSave(formData);
        closeUploadingModal();
    }

    if (_.isNil(eventInfo) || _.isNil(formData)) {
        return <SpinnerMedium />
    }

    return (
        <Card>
            <div className="p-3 flex flex-col space-y-2">
                <PageTitle>이벤트정보 수정</PageTitle>
                {!hideId &&
                    <div>
                        <div className="font-semibold">
                            이벤트 ID
                        </div>
                        <Input
                            value={eventInfo?.id}
                            disabled={true}
                        />
                    </div>
                }
                {!hideClinic &&
                    <div>
                        <div className="font-semibold">
                            의원
                        </div>
                        <ComboBox
                            items={infoService.getClinics()}
                            selectedItem={selectedClinicItem}
                            onChange={(item) => { setSelectedClinicItem(item); setFormData({ ...formData, clinicId: item?.id }) }}
                        />
                    </div>
                }
                <div>
                    <div className="font-semibold">
                        이벤트명
                    </div>
                    <Input
                        value={formData.title}
                        onChange={(value) => setFormData({ ...formData, title: value })}
                    />
                </div>
                <div>
                    <div className="font-semibold">
                        내용
                    </div>
                    <Textarea
                        value={formData.content}
                        onChange={(value) => setFormData({ ...formData, content: value })}
                        resizable={true}
                    />
                </div>
                <div>
                    <div className="font-semibold">
                        시술명
                    </div>
                    <EmptyForm>
                        <div className="p-2">
                            <MultiBadgeCombo
                                items={infoService.getTreatments()}
                                selectedItems={formData?.treatments}
                                onSelectedItemsChange={(items) => {
                                    console.log("[EventEditPage] onSelectedItemsChange", items);
                                    setFormData({
                                        ...formData,
                                        treatments: items
                                    })
                                }}
                            />
                        </div>
                    </EmptyForm>
                </div>
                <div>
                    <div className="font-semibold">
                        대표 이미지
                    </div>
                    <EmptyForm>
                        <SingleImageUploader
                            file={formData.mainImage}
                            onFileSelected={(file) => setFormData({ ...formData, mainImage: file })}
                            onFileChanged={(file) => setFormData({ ...formData, mainImage: file })}
                        />
                    </EmptyForm>
                </div>
                <div>
                    <div className="font-semibold">
                        카드 이미지
                    </div>
                    <EmptyForm>
                        <SingleImageUploader
                            file={formData.cardImage}
                            onFileSelected={(file) => setFormData({ ...formData, cardImage: file })}
                            onFileChanged={(file) => setFormData({ ...formData, cardImage: file })}
                        />
                    </EmptyForm>
                </div>
                <div>
                    <div className="font-semibold">
                        상세 이미지
                    </div>
                    <EmptyForm>
                        <MultiImageUploader
                            files={formData.detailImages}
                            onFileSelected={(files) => setFormData((prev) => ({ ...prev, detailImages: [...prev.detailImages, ...files] }))}
                            onFileChanged={(files) => setFormData((prev) => ({ ...prev, detailImages: files }))}
                        />
                    </EmptyForm>
                </div>
                <div className="border-t border-gray-300"></div>
                <div>
                    <div className="flex justify-between space-x-2">
                        <div>
                            <Button
                                onButtonClicked={() => { navigate("/main/doctor") }}
                            >
                                목록
                            </Button>
                        </div>
                        <div className="flex space-x-2">
                            <div>
                                <Button
                                    onButtonClicked={() => {
                                        const tempEventInfo = {
                                            ..._.omit(formData, ["clinicId", "treatmentIds"]),
                                            clinic: selectedClinicItem,
                                            treatments: formData.treatmentIds.map((id) => infoService.getTreatmentById(id))
                                        }
                                        window.localStorage.setItem("tempEventInfo", JSON.stringify(tempEventInfo));
                                        window.open(`/preview/event/pv`, "_blank");
                                    }}
                                >
                                    미리보기
                                </Button>
                            </div>
                            <div>
                                <Button
                                    onButtonClicked={handleSave}
                                >
                                    저장
                                </Button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <UploadingModal>
                <FileUploadingSpinner />
            </UploadingModal>
        </Card>
    )
}

export default EventEditForm;
